// extracted by mini-css-extract-plugin
export default {"block":"Summary_block__4vfpu","vector":"Summary_vector__TFF0d","category":"Summary_category__sY9q4","line":"Summary_line__YxS1U"};